 <aims-common-table
        id="areas-table"
        [dataSource]="areas | async"
        [defaultTableState] = "{ sort:{ active : 'area', direction: 'asc' }}"
        [addRowInitialObject]="defaultItem"
        [header]="tableHeader"
        [permissions]="tablePermissions"
        [pageSize]="15"
        (rowUpdated)="handleRowUpdate($event)"
        (rowAdded)="handleRowAdded($event)"
        (rowDeleted)="handleRowDelete($event)"
        [stickyHeader]="true">

  </aims-common-table>
